module.exports = __webpack_public_path__ + "27dbd67def67fa2ad67cac378d1ea81f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/MilkyChance_Blossom_FrontCover.png
// module id = 267
// module chunks = 0